import { ReactNode, useState } from 'react';
import { InboxTotalContext, inboxTotalContextDefaultValue } from './context';

export const InboxTotalProvider = ({ children }: { children: ReactNode }) => {
  const [inboxTotal, setInboxTotal] = useState(inboxTotalContextDefaultValue.inboxTotal);

  return <InboxTotalContext.Provider value={{ inboxTotal, setInboxTotal }}>{children}</InboxTotalContext.Provider>;
};
